import { useUiFramework } from '../../providers/UiFrameworkProvider'

import { RecurrenceTypeDropdown as LegacyRecurrenceTypeDropdown } from './legacy/RecurrenceTypeDropdown'
import { RecurrenceTypeDropdown as TidalRecurrenceTypeDropdown } from './tidal/RecurrenceTypeDropdown'

export function RecurrenceTypeDropdown() {
  const uiFramework = useUiFramework()

  switch (uiFramework) {
    case 'legacy':
      return <LegacyRecurrenceTypeDropdown />

    case 'tidal':
      return <TidalRecurrenceTypeDropdown />
  }
}
